// extracted by mini-css-extract-plugin
module.exports = {"topTokensItems":"styles_topTokensItems__1CubH","tokenLogoWrapper":"styles_tokenLogoWrapper__5J4L2","tokenLogo":"styles_tokenLogo__MhX4V","moreIcon":"styles_moreIcon__cqPUI"};